'use client';

import { useRouter } from 'next/navigation';
import { toast } from 'sonner';
import { clearQueryCache } from '@/components/providers/query-provider';
import { Button } from '@/components/ui/button';
import { useImpersonationStore } from '@/lib/stores/impersonation-store';
import { useInstallationStore } from '@/lib/stores/installation-store';
export function ImpersonationBanner() {
  const router = useRouter();
  const {
    clearImpersonation,
    impersonatedInstallationId,
    impersonatedInstallationName
  } = useImpersonationStore();
  const {
    setSelectedInstallationId
  } = useInstallationStore();

  // If no impersonation is active, don't show the banner
  if (!impersonatedInstallationId) {
    return null;
  }
  const handleExitImpersonation = async () => {
    try {
      // Reset installation store
      setSelectedInstallationId(null);

      // Clear impersonation state
      clearImpersonation();

      // Clear all cached data
      await clearQueryCache();

      // Redirect to the appropriate admin page
      const redirectPath = impersonatedInstallationId ? '/super-admin/installation' : '/super-admin';
      router.push(redirectPath);
      toast.success('Successfully ended impersonation session');
    } catch (error) {
      console.error('Error ending impersonation:', error);
      toast.error('Failed to end impersonation');
    }
  };
  return <div className="sticky top-0 z-50 w-full bg-amber-50 border-b border-amber-200">
      <div className="container max-w-7xl mx-auto py-2 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex flex-col text-sm text-amber-800">
            {impersonatedInstallationName && <span>
                Impersonating with installation:{' '}
                <span className="font-medium">{impersonatedInstallationName}</span>
              </span>}
          </div>
          <Button variant="outline" size="sm" onClick={handleExitImpersonation} className="text-amber-800 hover:text-amber-900 border-amber-300 hover:bg-amber-100">
            Exit Impersonation
          </Button>
        </div>
      </div>
    </div>;
}